import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { IServiceOrder } from 'src/app/serviceorder/models/IServiceOrder';
import { IServiceOrderEvent } from 'src/app/serviceorder/models/IServiceOrderEvent';

@Component({
    selector: 'app-so-texts',
    templateUrl: './so-texts.component.html',
    styleUrl: './so-texts.component.scss',
    standalone: false
})
export class SoTextsComponent implements OnInit {
  assignmentTexts: IServiceOrderEvent[] = [];
  internTexts: IServiceOrderEvent[] = [];
  reasons: IServiceOrderEvent[] = [];
  actions: IServiceOrderEvent[] = [];

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: IServiceOrder,
  private _bottomSheetRef: MatBottomSheetRef<SoTextsComponent>) {}

  ngOnInit(): void {
    this.assignmentTexts = this.data.serviceOrderEvents.filter(e => e.soet?.codCode === 'U').sort((a, b) => a.soeModifyDate < b.soeModifyDate ? 1 : -1);
    this.internTexts = this.data.serviceOrderEvents.filter(e => e.soet?.codCode === 'I').sort((a, b) => a.soeModifyDate < b.soeModifyDate ? 1 : -1);
    this.reasons = this.data.serviceOrderEvents.filter(e => e.soet?.codCode === 'O').sort((a, b) => a.soeModifyDate < b.soeModifyDate ? 1 : -1);
    this.actions = this.data.serviceOrderEvents.filter(e => e.soet?.codCode === 'Å').sort((a, b) => a.soeModifyDate < b.soeModifyDate ? 1 : -1);
  }
  close() {
    this._bottomSheetRef.dismiss();
  }
}
